import { RenderBankLogo } from '@components/RenderBankPaymentMethod';
import { PaymentMethodType } from '@pages/types';

const PaymentMethodList: React.FC<PaymentMethodType> = ({
  data,
  settings,
  selectedPaymentType,
  setSelectedPaymentType,
}) => {
  const lightenColor = (hex: string, percent: number): string => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);

    const newR = Math.round(r + (255 - r) * percent);
    const newG = Math.round(g + (255 - g) * percent);
    const newB = Math.round(b + (255 - b) * percent);

    return `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB.toString(16).padStart(2, '0')}`.toUpperCase();
  };

  if (!data?.length) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2 py-3">
      {data.map((item) => {
        const isActive = selectedPaymentType?.id === item.id;
        const displayCode = item.code || 'QRIS';
        const itemIdString = String(item.id);

        return (
          <div className="flex flex-col gap-2" key={item.id}>
            <label
              htmlFor={itemIdString}
              className="cursor-pointer rounded-lg border p-4 transition-all"
              style={{
                backgroundColor: isActive
                  ? lightenColor(settings.button_color, 0.9)
                  : '#FFFFFF',
                boxShadow: isActive
                  ? `0 0 0 2px ${lightenColor(settings.button_color, 0.7)}`
                  : 'none',
              }}
            >
              <div className="flex flex-row items-center justify-between">
                <div className="flex items-center justify-center rounded-md bg-white p-1">
                  <RenderBankLogo
                    title={displayCode}
                    name={item.name}
                    key={item.id}
                    idx={item.id}
                  />
                </div>
                <div className="flex flex-row items-center gap-2">
                  <input
                    id={itemIdString}
                    name={itemIdString}
                    type="radio"
                    aria-describedby={`${itemIdString}-description`}
                    className="h-4 w-4 rounded-full border-gray-300 focus:ring-primary-light"
                    checked={isActive}
                    onChange={() => setSelectedPaymentType?.(item)}
                    style={{
                      color: settings.button_color,
                    }}
                  />
                </div>
              </div>
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default PaymentMethodList;
